import { render } from "./FilterSegments.vue?vue&type=template&id=119dadb9"
import script from "./FilterSegments.vue?vue&type=script&lang=js"
export * from "./FilterSegments.vue?vue&type=script&lang=js"
script.render = render

export default script